<template>
    <div class="templates-container">
        <div class="templates">
            <div v-if="$slots.filters" class="filters">
                <slot name="filters" />
            </div>

            <div
                v-if="items.length === 0 && !isLoading && !error"
                class="templates-empty-state"
            >
                <slot name="empty" />
            </div>

            <slot v-if="items.length > 0" name="static" />

            <div
                v-for="item in items"
                :key="`${item.id}-${item.templateType}`"
                class="template-card"
            >
                <slot name="card" :item="item" />
            </div>

            <template v-if="isLoading">
                <TemplateGalleryPlaceholderCard
                    v-for="n in pageSize"
                    :key="`placeholder-${n}`"
                    class="template-card"
                />
            </template>
        </div>

        <ScrollTarget
            v-if="!isLoading && !isFullyLoaded && !error"
            :root="$el"
            @intersect="$emit('fetch')"
        />
    </div>
</template>

<script>
import TemplateGalleryPlaceholderCard from './TemplateGalleryPlaceholderCard';
import ScrollTarget from './ScrollTarget';

export default {
    components: {
        TemplateGalleryPlaceholderCard,
        ScrollTarget,
    },

    props: {
        items: {
            type: Array,
            required: true,
        },
        pageSize: {
            type: Number,
            required: true,
        },
        isLoading: Boolean,
        isFullyLoaded: Boolean,
        error: Error,
    },
};
</script>

<style lang="scss" scoped>
@import './variables';

.templates-container {
    flex: 1;
    padding: $spacing-400;
    height: 100%;
    overflow-y: auto;
}

.filters {
    margin-bottom: $spacing-100;
}

.templates-empty-state {
    display: flex;
    justify-content: center;
}

.filters,
.templates-empty-state {
    grid-column: 1 / -1;
}

.templates {
    display: grid;
    grid-template-columns: repeat(auto-fill, $card-size);
    grid-gap: $spacing-300;
    justify-content: center;

    &> .template-card {
        width: $card-size;
        height: $card-size;
    }
}

.template-card > * {
    height: 100%;
}

.templates-spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
</style>
